<div
  class="feedback-carousel"
  data-carousel="slide"
  role="region"
  aria-roledescription="carousel"
  aria-label="User feedback carousel"
  [attr.aria-live]="announcesSlideChanges ? 'polite' : 'off'"
  tabindex="0"
  (keydown)="onKeydown($event)"
  (mouseenter)="onPointerEnter()"
  (mouseleave)="onPointerLeave()"
  (focusin)="onPointerEnter()"
  (focusout)="onPointerLeave()"
  (touchstart)="onTouchStart($event)"
  (touchend)="onTouchEnd($event)"
>
  <!-- Carousel wrapper -->
  <div class="feedback-carousel__wrapper">
    <div class="feedback-carousel__track" [style.transform]="'translateX(-' + activeSlideIndex * 100 + '%)'">
      @for (feedback of userFeedbacks; track feedback.user.fullName; let i = $index) {
        <div
          class="feedback-carousel__item"
          data-carousel-item
          role="group"
          aria-roledescription="slide"
          [attr.aria-label]="'Slide ' + (i + 1) + ' of ' + userFeedbacks.length"
          [attr.aria-hidden]="activeSlideIndex === i ? 'false' : 'true'"
        >
          <div class="sectionId_userfeedback sectionAnchor flexBoxOuter" *transloco="let t">
            <div class="flexBoxInner txt marginRight" style="hyphens: auto">
              <div>
                <h3 class="kennwertered">{{ t(feedback.headline) }}</h3>
              </div>
              <div
                class="feedback-user-row"
              >
                <div class="feedback-user-main">
                  <img
                    style="height: 100px; width: 100px; float: left; vertical-align: center; border-radius: 50%;"
                    [src]="feedback.user.portraitImage"
                  />
                  <div style="display: flex; flex-direction: column">
                    <span style="font-weight: bold"> {{ t(feedback.user.fullName) }}</span>
                    <span> {{ t(feedback.user.title) }}</span>
                    <span> {{ t(feedback.user.position) }}</span>
                  </div>
                </div>
                <div class="feedback-user-logo-wrap">
                  <img
                    class="feedback-user-logo"
                    [src]="feedback.logoImage"
                  />
                </div>
              </div>

              <div class="brightfont clearFloat">
                <p style="margin-top: 20px" [innerHTML]="t(feedback.text1)"></p>
                <p style="margin-top: 20px" [innerHTML]="t(feedback.text2)"></p>
              </div>
            </div>
            <div class="flexBoxInner img">
              <div class="centerImage centerImgVertically">
                <img
                  id="userBuilding"
                  [src]="feedback.buildingImage"
                  style="width: 100%; height: 100%; object-fit: contain; align-self: center"
                />
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
  <!-- Slider indicators -->
  <div class="feedback-carousel__indicators">
      @for (feedback of userFeedbacks; track feedback.user.fullName; let i = $index) {
      <button
        type="button"
        class="feedback-carousel__indicator"
        [attr.aria-current]="activeSlideIndex === i"
        [attr.aria-label]="'Slide ' + (i + 1)"
        [attr.data-carousel-slide-to]="i"
        (click)="goToSlide(i)"
      ></button>
    }
  </div>
  <!-- Slider controls -->
  <button
    type="button"
    class="feedback-carousel__control feedback-carousel__control--prev"
    aria-label="Previous slide"
    data-carousel-prev
    (click)="prevSlide()"
  >
    <span class="feedback-carousel__control-icon-wrap">
      <svg
        class="feedback-carousel__control-icon"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="m15 19-7-7 7-7"
        />
      </svg>
    </span>
  </button>
  <button
    type="button"
    class="feedback-carousel__control feedback-carousel__control--next"
    aria-label="Next slide"
    data-carousel-next
    (click)="nextSlide()"
  >
    <span class="feedback-carousel__control-icon-wrap">
      <svg
        class="feedback-carousel__control-icon"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m9 5 7 7-7 7" />
      </svg>
    </span>
  </button>
</div>
